export const MODAL_TOGGLE = `MODAL_TOGGLE`;
export const MODAL_TITLE = `MODAL_TITLE`;
export const SCROLL_MULTIPLE_OPTIONS = `SCROLL_MULTIPLE_OPTIONS`;
export const _BACK = `BACK`;
